module.exports = __webpack_public_path__ + "static/media/facebook_icon.d34f2257.svg";